import { useState } from 'react'
import { CheckCircle2, CircleDashed } from 'lucide-react'
import type { Project } from '../data/projectTypes'
import { TRACKER_NAMES, connectedIssueTracker } from '../lib/agentConnection'
import IssueTrackerChatCard from './chat/IssueTrackerChatCard'
import './TestingSetup.css'
import './SetupPage.css'
import './chat/chat.css'

export default function IssueTrackerSetup({ project, canEdit }: { project: Project; canEdit: boolean }) {
  const [trackerOpen, setTrackerOpen] = useState(false)
  const tracker = connectedIssueTracker(project)
  return <div className="agent-connection testing-settings setup-stack">
    <section className="setup-section" aria-labelledby="issue-tracker-title">
      <header className="setup-section__header">
        <div>
          <h2 id="issue-tracker-title">Issue tracker</h2>
          <p>QA files each new bug as an issue, so your team can triage it where they already work.</p>
        </div>
        {canEdit && !trackerOpen && <div className="setup-section__actions">
          <button type="button" className={tracker ? undefined : 'testing-setup__primary'} onClick={() => setTrackerOpen(true)}>
            {tracker ? 'Manage issue tracker' : 'Connect issue tracker'}
          </button>
        </div>}
      </header>
      <div className="setup-section__body">
        {tracker ? <p className="setup-status setup-status--success">
          <CheckCircle2 size={16} aria-hidden /><strong>Connected to {tracker.name}</strong>
          {tracker.destination && <code className="setup-status__detail">{tracker.destination}</code>}
        </p> : <>
          <p className="setup-status"><CircleDashed size={16} aria-hidden /><strong>No issue tracker connected</strong></p>
          <div>
            <p className="setup-label">Supported trackers</p>
            <ul className="setup-chips" aria-label="Supported trackers">
              {Object.values(TRACKER_NAMES).map(name => <li key={name}>{name}</li>)}
            </ul>
          </div>
        </>}
        {canEdit && trackerOpen && <div className="agent-connection__tracker">
          <IssueTrackerChatCard project={project} onClose={() => setTrackerOpen(false)} />
        </div>}
        {!canEdit && <p>A project member can connect an issue tracker.</p>}
      </div>
    </section>
  </div>
}
